// Chart colours for the dark app surface (zinc-900, #18181b).
// Categorical order is fixed (assigned by position, never cycled): checked with
// the dataviz validator in dark mode on #18181b -- lightness band, chroma,
// adjacent CVD separation (worst 8.4) and >= 3:1 contrast all pass.
export const SERIES = [
  '#3987e5', // blue
  '#d95926', // orange
  '#199e70', // aqua
  '#c98500', // yellow
  '#d55181', // magenta
  '#008300', // green
  '#9085e9', // violet
  '#e66767', // red
];

// A pie past this many slices folds the rest into "Other".
export const MAX_SLICES = SERIES.length - 1;

export const SURFACE = '#18181b';
export const TEXT_PRIMARY = '#f4f4f5'; // zinc-100
export const TEXT_SECONDARY = '#a1a1aa'; // zinc-400
export const GRID = '#27272a'; // zinc-800, recessive

export const axisProps = {
  stroke: GRID,
  tick: { fill: TEXT_SECONDARY, fontSize: 11 },
  tickLine: false,
  axisLine: false,
};

export const tooltipProps = {
  contentStyle: {
    background: '#09090b',
    border: '1px solid #3f3f46',
    borderRadius: 8,
    fontSize: 12,
    color: TEXT_PRIMARY,
  },
  labelStyle: { color: TEXT_SECONDARY },
  itemStyle: { color: TEXT_PRIMARY },
};

const compact = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const full = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });

export const formatValue = (value) =>
  typeof value === 'number' ? full.format(value) : String(value ?? '');
export const formatTick = (value) =>
  typeof value === 'number' ? compact.format(value) : String(value ?? '');
